import React from "react";
import SignBuilder from "./SignBuilder";

export default function Foamboard() {
  return <SignBuilder product="foamboard" />;
}
